<template>
  <div class="hm-card" :class="($template === 'article') ? 'article' : 'small'">
    <div class="max-w">
      <h2>What is Your Income?</h2>
      <p>Include total compensation from retirement benefits
          and work income that you and/or your spouse receive.</p>
    </div>
    <SuiDivider inverted v-if="($template === 'small')"/>
    <div class="max-w text-center">
      <div :class="{ 'flex-columns': ($template === 'article') }">
        <div v-if="($template === 'article') || step === 1" class="income-card" :class="{ 'article': ($template === 'article') }">
          <CheckSelectInput
            label="Do you receive monthly checks for retirement benefits such as Social Security, pensions, or annuities?"
            tooltip="This is the amount you collect each month. It includes Social Security, pension, annuities, workers' compensation, rental income, and other retirement benefits."
            image-name="Capitol.svg"
            yes="Yes, I do."
            no="No, I do not."
            v-model="hasMonthlyChecks"
          />
          <br/>
          <div class="dropdown" v-if="hasMonthlyChecks">
            <p style="margin-top:1em;">How much do you receive monthly?</p>
            <SuiInput
              v-if="hasMonthlyChecks"
              icon="dollar sign"
              icon-position="left"
              type="number"
              step=".01"
              min="0"
              v-model="$store.getters['getData']().houseHoldIncome.monthlyChecks"
              @input="onMonthlyChecksInput"
            />
          </div>
        </div>
        <div v-if="($template === 'article') || step !== 1" class="income-card" :class="{ 'article': ($template === 'article') }">
          <CheckSelectInput
            label="In 2020, did you receive income for working?"
            tooltip="Earned income is the amount you earn from working each month/year. This amount includes any wages collected and any net earnings from self-employment."
            image-name="paycheck.svg"
            yes="Yes, I work and receive a paycheck."
            no="No, I do not work."
            v-model="hasWorkingIncome"
          />
          <br>
          <div class="dropdown" v-if="hasWorkingIncome">
            <p style="margin-top:1em;">How much do you receive annually?</p>
            <SuiInput
              icon="dollar sign"
              icon-position="left"
              type="number"
              step=".01"
              min="0"
              v-model="$store.getters['getData']().houseHoldIncome.workingIncome"
              @input="onWorkingIncomeInput"
            />
          </div>
        </div>
      </div>
      <br>
      <SuiButton
        :class="{ 'article': ($template === 'article') }"
        color="green"
        content="Next"
        :disabled="isNextDisabled()"
        @click="() => goNextStep('people-in-household')"
      />
    </div>
  </div>
</template>

<script>
  import {Button} from 'semantic-ui-vue/dist/commonjs/elements/Button';
  import {Divider} from 'semantic-ui-vue/dist/commonjs/elements/Divider';
  import {Input} from 'semantic-ui-vue/dist/commonjs/elements/Input';
  import CheckSelectInput from '@/components/CheckSelectInput';

  export default {
    name: 'HouseholdIncome',
    components: {
      SuiButton: Button,
      SuiDivider: Divider,
      SuiInput: Input,
      CheckSelectInput,
    },
    data() {
      return {
        step: 1,
        hasMonthlyChecks: false,
        hasWorkingIncome: false,
      }
    },
    methods: {
      isNextDisabled() {
        return (
          this.$data.hasMonthlyChecks &&
          !this.$store.getters['getData']().houseHoldIncome.monthlyChecks
          ||
          this.$data.hasWorkingIncome &&
          !this.$store.getters['getData']().houseHoldIncome.workingIncome
        )
      },
      goNextStep(step) {
        if (this.$template == 'small') {
          if (this.$data.step === 1) {
            this.$data.step = 2;
          } else {
            this.$store.commit('setStep', step);
          }
        } else {
          this.$store.commit('setStep', step);
        }

        if (this.$template == 'landing') {
          window.scrollTo(0,0);
        }
      },
      onMonthlyChecksInput(value) {
        this.$store.commit('setMonthlyChecks', value);
      },
      onWorkingIncomeInput(value) {
        this.$store.commit('setWorkingIncome', value);
      },
    },
  }
</script>
